import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Processor from "./component";
import {
  getPaymentProcessorslist,
  updatePaymentProcessorDetails,
  isAdminUser,
} from "./actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPaymentProcessorslistConnect: getPaymentProcessorslist,
      updatePaymentProcessorDetailsConnect: updatePaymentProcessorDetails,
      isAdminUserConnect: isAdminUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Processor);
